<template>
    <div class="container-fluid">
        <!-- Real-time Overview Section -->
        <div class="row">
            <StudentCard />
        </div>

        <div class="row">
            <TicketVolumeTrend />

            <InOutTickets />
        </div>

        <!-- <div class="row">
            <PriorityBreakdown />
            <WorkTypePriorityMatrix />
        </div>

        <div class="row">
            <PerformanceMetrics />
        </div> -->
    </div>
</template>

<script setup>
import { ref , defineAsyncComponent } from 'vue'
import TicketStatsCard from './components/TicketStatsCard.vue'
import TicketVolumeTrend from './components/TicketVolumeTrend.vue'
import PriorityBreakdown from './components/PriorityBreakdown.vue'
import WorkTypePriorityMatrix from './components/WorkTypePriorityMatrix.vue'
import InOutTickets from './components/InOutTickets.vue'
import PerformanceMetrics from './components/PerformanceMetrics.vue'
import TeamWorkload from './components/TeamWorkload.vue'

const StudentCard = defineAsyncComponent(() => import("./components/StudentCard.vue"))

// Ticket statistics data
const ticketStats = ref({
    totalOpen: 324,
    newTickets: 48,
    pending: 87,
    resolvedToday: 45,
    overdue: 23
})
</script>